<form [formGroup]="currentForm">
  <div class="wrapper">
    <div class="col" fxFlex="100">
      <div fxLayout="row" fxFlexAlign="stretch">
        <mat-form-field appearance="outline" fxFlex="35" name="date" style="margin-right: 1rem">
          <mat-label>Datum:</mat-label>
          <input
            matInput
            formControlName="date"
            [matDatepicker]="supplyAppointment"
            placeholder="Durchführungstermin:" />
          <mat-datepicker-toggle matSuffix [for]="supplyAppointment"></mat-datepicker-toggle>
          <mat-datepicker #supplyAppointment></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="17" name="time">
          <mat-label>Uhr:</mat-label>
          <input matInput type="time" formControlName="time" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <mat-error *ngIf="!currentForm.valid">Datum und Uhrzeit sind erforderlich</mat-error>
</form>

<p>Hinweis: Wenn Sie den Durchführungstermin ändern, wird eine Benachrichtigung über das Portal versendet.</p>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>

  <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">
    Speichern und E-Mail an Kunde senden
  </button>
</div>
